import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/pages/Home/Home';
import About from './components/pages/About/About';
import WebDevServices from './components/pages/WebDevServices/WebDevServices';
import CustomSWServices from './components/pages/CustomSWServices/CustomSWServices';
import Contact from './components/pages/Contact/Contact';
import Demos from './components/pages/Demos/Demos';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/about" element={<About/>}/>
        <Route path="/demos" element={<Demos/>}/>
        <Route path="/Services/WebDevelopment" element={<WebDevServices/>}/>
        <Route path="/Services/CustomSoftware" element={<CustomSWServices/>}/>
        <Route path="/contact" element={<Contact/>}/>
      </Routes>
    </Router>
  );
}

export default App;
